import React, { useState, useCallback } from 'react';
//////////////////////////////////////////////////

const useMaintenanceNotes = (initialNotes = []) => {
  const [maintenanceNotes, setMaintenanceNotes] = useState(initialNotes);

  const getNotes = useCallback(() => maintenanceNotes, [maintenanceNotes]);

  const addNote = useCallback((note) => {
    setMaintenanceNotes((prevNotes) => [...prevNotes, note]);
  }, []);

  const updateNote = useCallback((index, updatedNote) => {
    setMaintenanceNotes((prevNotes) =>
      prevNotes.map((note, i) => (i === index ? updatedNote : note)),
    );
  }, []);

  const deleteNote = useCallback((index) => {
    setMaintenanceNotes((prevNotes) => prevNotes.filter((_, i) => i !== index));
  }, []);

  return {
    addNote,
    getNotes,
    updateNote,
    deleteNote,
    maintenanceNotes,
  };
};

const withMaintenanceNotes = ({ initialNotes = [] }) => (Component) => (props) => {
  const hook = useMaintenanceNotes(initialNotes);

  return <Component {...props} {...hook} />;
};


export default useMaintenanceNotes;

export {
  useMaintenanceNotes,
  withMaintenanceNotes,
};
